module.exports = __webpack_public_path__ + "img/57.3.TP.4d7625e7.png";